<template>
  <div class="plant-wrapper">
    <div class="plant-wrapper-top">
      <div class="handle-wrapper" @click="backPath"><div class="icon-font">&#xe612;</div>返回</div>
      <div class="plant-wrapper-top-title">监控规则设置</div>
      <div class="handle-wrapper" @click="handleData"><div class="icon-font">&#xe653;</div>保存</div>
    </div>
    <div class="regular-content">
      <div class="regular-content-list">
        <div>固定巡查时间设置：</div>
        <div class="week-list" v-for="(data,index) in weeks" :key="index" :class="{'week-list-active':data.sign === '1'}" @click="changeBg(data, index)">{{data.title}}</div>
      </div>
      <div class="regular-content-list">
        <div>更换虫情板虫数量：</div>
        <div class="input-wrapper">
          <input v-model="boardPestLimit"/>
        </div>
      </div>
      <div class="regular-content-list">
        <div>虫数超出提醒设置：</div>
        <div class="input-wrapper">
          <input v-model="outNumber"/>
        </div>
      </div>
      <div class="regular-content-list">
        <div>人员添加删除设置：</div>
        <div class="two-font-wrapper" style="margin-right: 1vw" @click="showAdd"><div class="icon-font">&#xe605;</div>添加</div>
        <div class="four-font-wrapper" @click="deleteAll"><div class="icon-font">&#xe646;</div>批量删除</div>
      </div>
      <div class="detail">
        <div class="detail-box" style="display: flex;flex-direction: column">
          <div class="loading-data" v-if="loading">
            <i class="el-icon-loading"></i>
            <div>加载中，请稍后···</div>
          </div>
          <div class="detail-nav">
            <div class="regular-title-item" style="width: 10%;">
              <div class="select-icon" :class="{'select-icon-active': all}" @click="selectAll"></div>
            </div>
            <div class="regular-title-item" style="width: 10%">序号</div>
            <div class="regular-title-item" style="width: 10%">姓名</div>
            <div class="regular-title-item" style="width: 10%">性别</div>
            <div class="regular-title-item" style="width: 10%">联系方式</div>
            <div class="regular-title-item" style="width: 10%">任务类型</div>
            <div class="regular-title-item" style="width: 30%">任务详情</div>
            <div class="regular-title-item" style="width: 10%">操作</div>
          </div>
          <div class="detail-content" style="flex: 1;padding-bottom: 0;overflow: auto">
            <div class="detail-list-wrapper" v-if="!loading && tableData.length>0" v-for="(data,index) in tableData" :key="index">
              <div class="regular-list" style="width: 10%">
                <div class="select-icon" :class="{'select-icon-active': data.sign === 1}" @click="selectSingle(data.id)"></div>
              </div>
              <div class="regular-list" style="width: 10%">{{index + 1}}</div>
              <div class="regular-list" style="width: 10%">{{data.userName}}</div>
              <div class="regular-list" style="width: 10%">{{data.sex === 1 ? '男' : '女'}}</div>
              <div class="regular-list" style="width: 10%">{{data.phone}}</div>
              <div class="regular-list" style="width: 10%">{{data.taskType === '01' ? '虫情巡查' : data.taskType === '02' ? '更换虫情板' : '其他'}}</div>
              <div class="regular-list" style="width: 30%">{{data.taskDetail}}</div>
              <div class="regular-list" style="width: 10%" @click="deleteCrib(data.id)"><span class="item-btn item-delete">删除</span></div>
            </div>
            <div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
          </div>
        </div>
        <transition name="fade">
          <div class="alert-box" v-if="show">
            <div class="alert-content">
              <div class="alert-content-title">删除提醒</div>
              <div class="alert-content-msg">是否确认删除选中数据?</div>
              <div class="alert-content-btn">
                <div class="btn-cancel button" @click="cancelDelete">取消</div>
                <div class="btn-confirm button" @click="confirmDelete">确认</div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <transition name="fade">
      <div class="alert-box" v-if="addShow">
        <div class="alert-add-content">
          <div class="alert-content-title">添加人员</div>
          <div class="alert-content-msg" style="padding-top: 1vw">
            <div class="alert-content-msg-list">
              <div style="margin-left: 1.8vw">人员：</div>
              <DropDownInput type="1" :items="custodianValue" content="" @sendValue="sendValue" @sendInfo="showInfo"></DropDownInput>
            </div>
            <div class="alert-content-msg-list" style="margin-left: 1vw">
              <div>任务类型：</div>
              <DropDown content="请选择任务类型" :items="typeData" v-on:sendInfo = "showInfoType"></DropDown>
            </div>
          </div>
          <div class="alert-content-msg" style="padding-top: 0">
            <div class="alert-content-msg-list" style="width: 100%">
              <div>任务详情：</div>
              <div class="text-wrapper">
                <label>
                  <textarea v-model="inputValue.taskDetail" rows="5"></textarea>
                </label>
              </div>
            </div>
          </div>
          <div class="alert-content-btn">
            <div class="btn-cancel button" @click="canelAdd">取消</div>
            <div class="btn-confirm button" @click="submitAdd">添加</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {queryPhases, setPhases, addPerson, delPerson, bathDelPerson} from '../../../api/maintain'
import {positiveInteger, noEmpty} from '../../../tools/methods'
import DropDownInput from '../../../components/DropDownInput.vue'
import DropDown from '../../../components/DropDownSingle.vue'
import {userList} from '../../../api/system'
export default {
  name: 'RegularPlant',
  components: { DropDownInput, DropDown },
  data () {
    return {
      loading: true,
      sex: true,
      show: false,
      all: false,
      addShow: false,
      id: '',
      type: 0,
      idList: [],
      weeks: [
        {title: '周一', value: '01', sign: '1'},
        {title: '周二', value: '02', sign: '0'},
        {title: '周三', value: '03', sign: '0'},
        {title: '周四', value: '04', sign: '0'},
        {title: '周五', value: '05', sign: '0'},
        {title: '周六', value: '06', sign: '0'},
        {title: '周日', value: '07', sign: '0'}
      ],
      boardPestLimit: '',
      outNumber: '',
      phases: '01',
      rId: '',
      tableData: [
        {name: '张三', sex: '1', mobile: '18100000000', type: '巡查虫情', sign: 0, id: 0},
        {name: '张三', sex: '1', mobile: '18100000000', type: '巡查虫情', sign: 0, id: 1},
        {name: '张三', sex: '1', mobile: '18100000000', type: '巡查虫情', sign: 0, id: 2},
        {name: '张三', sex: '1', mobile: '18100000000', type: '巡查虫情', sign: 0, id: 3},
        {name: '张三', sex: '1', mobile: '18100000000', type: '巡查虫情', sign: 0, id: 4}
      ],
      custodianValue: [],
      inputValue: {
        pestValSetId: '',
        taskDetail: '',
        taskType: '',
        userId: ''
      },
      typeData: [
        {name: '虫情巡查', value: '01'},
        {name: '更换虫情板', value: '02'},
        {name: '其他', value: '03'}
      ]
    }
  },
  created () {
    this.handleSearch()
  },
  methods: {
    showInfoType: function (data) {
      this.inputValue.taskType = data.value
    },
    showInfo: function (data) {
      this.inputValue.userId = data.id
    },
    sendValue: function (value) {
      this.handleSearchValue(value)
    },
    handleSearchValue: function (value) {
      let body = {
        keywork: value,
        page: 1,
        rows: 9999
      }
      userList(body).then(res => {
        console.log(res)
        this.custodianValue = res.data.rows
        this.addShow = true
      }).catch(err => {
        console.log(err)
      })
    },
    backPath: function () {
      this.$router.go(-1)
    },
    handleSearch: function () {
      let body = {
        phases: this.phases
      }
      this.loading = true
      queryPhases(body).then(res => {
        console.log(res)
        this.boardPestLimit = res.data.boardPestLimit
        this.outNumber = res.data.outNumber
        this.rId = res.data.id
        res.data.pestValuePersonSettingList && res.data.pestValuePersonSettingList.map(item => {
          item.sign = 0
        })
        this.tableData = res.data.pestValuePersonSettingList
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    },
    changeBg: function (item, index) {
      this.phases = item.value
      this.handleSearch()
      this.weeks.map((data, int) => {
        data.sign = '0'
        if (index === int) {
          data.sign = '1'
        }
      })
    },
    selectAll: function () {
      this.type = 1
      this.all = !this.all
      let idList = []
      if (this.all) {
        this.tableData.map((data, index) => {
          data.sign = 1
          idList.push(data.id)
        })
        this.idList = idList
      } else {
        this.tableData.map((data, index) => {
          data.sign = 0
          this.idList = []
        })
      }
    },
    selectSingle: function (id) {
      this.tableData.map((data, index) => {
        if (id === data.id) {
          data.sign = data.sign === 1 ? 0 : 1
          if (data.sign === 1) {
            this.idList.push(data.id)
          } else {
            let idList = []
            this.idList.map((item, index) => {
              if (item !== id) {
                idList.push(item)
              }
            })
            this.idList = idList
          }
          console.log(this.idList)
        }
      })
      this.all = this.idList.length === this.tableData.length
    },
    deleteCrib: function (id) {
      this.show = true
      this.id = id
      this.type = 0
    },
    deleteAll: function () {
      if (this.idList.length !== 0) {
        this.show = true
        this.type = 1
      } else {
        this.$message({
          message: '请选择要删除的数据!',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
      console.log(this.idList)
    },
    cancelDelete: function () {
      this.show = false
    },
    confirmDelete: function () {
      if (this.type === 0) {
        let body = {
          valPestPersonSetId: this.id
        }
        console.log(body)
        delPerson(body).then(res => {
          console.log(res)
          this.$message({
            message: res.data,
            type: 'success',
            center: 'true',
            duration: '1000',
            customClass: 'user-message'
          })
          this.show = false
          this.id = ''
          this.handleSearch()
        }).catch(err => {
          console.log(err)
        })
      } else {
        let body = {
          valPestPersonSetIdLs: this.idList.join()
        }
        console.log(body)
        bathDelPerson(body).then(res => {
          console.log(res)
          this.all = false
          this.idList = []
          this.$message({
            message: res.data,
            type: 'success',
            center: 'true',
            duration: '1000',
            customClass: 'user-message'
          })
          this.show = false
          this.handleSearch()
        }).catch(err => {
          console.log(err)
        })
      }
    },
    showAdd: function () {
      if (this.rId) {
        this.inputValue = {
          pestValSetId: this.rId,
          taskDetail: '',
          taskType: '',
          userId: ''
        }
        this.handleSearchValue()
      } else {
        this.$message({
          message: '请先保存!',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
    },
    changSexM: function () {
      this.sex = true
    },
    changSexW: function () {
      this.sex = false
    },
    canelAdd: function () {
      this.addShow = false
    },
    submitAdd: function () {
      if (
        noEmpty(this.inputValue.userId, '请选择人员！') &&
        noEmpty(this.inputValue.taskType, '请选择任务类型！')
      ) {
        addPerson(this.inputValue).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.$message({
              message: '添加成功！',
              type: 'success',
              center: 'true',
              duration: '1000'
            })
            this.addShow = false
            this.handleSearch()
          } else {
            this.$message({
              message: res.message,
              type: 'warning',
              center: 'true',
              duration: '1000'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    handleData: function () {
      if (
        positiveInteger(this.boardPestLimit, '请输入正整数！') &&
        positiveInteger(this.outNumber, '请输入正整数！')
      ) {
        let body = {
          boardPestLimit: this.boardPestLimit,
          dateType: this.phases,
          outNumber: this.outNumber,
          id: this.rId
        }
        setPhases(body).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.rId = res.data
            this.$message({
              message: '监控规则设置成功！',
              type: 'success',
              center: 'true',
              duration: '1000'
            })
          } else {
            this.$message({
              message: res.data,
              type: 'warning',
              center: 'true',
              duration: '1000'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>

<style scoped>
@import "Plant.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/plant/RegularPlant.vue